import React, { useEffect, useState }  from 'react';
import DBABasicInfoComponent from './global-dba-regsitry-basic-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import GlobalDBAGatewayRegistryComponent from './global-dba-gateway-registry.component';
import { useSearchParams } from 'react-router-dom';
import GlobalDBARegistriesBasicInfoComponent from './global-dba-registries-basic-info.component';
import GlobalDBARegistriesGSTInfoComponent from './global-dba-registries-gst-info.component';
import DbaRegistriesPanInfoComponent from './global-dba-registries-pan-info.component';
import GlobalDBARegistriesKeypairInfoComponent from './global-dba-registries-keypair-info.component';

export const DBAComponent = ({countries,domains,subDomains,opsnumber,dbnpname,id,gatewayIds,handleFormChange,selectedDba,handleInnerFormChange,accounts,back,handleFormSubmit}: any) => {
  const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<DBABasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedDba={selectedDba}
        handleFormChange={handleFormChange}
        accounts={accounts}
        />,
    isVisible:true,
    },
      {
               id:2,
               title:'Global DBA Registry Information',
               component: <GlobalDBARegistriesBasicInfoComponent 
               handleBacicInnerFormChange={handleInnerFormChange}
               selectedDba={selectedDba}
               dbnpname={dbnpname}
               opsnumber={opsnumber}
               subDomains={subDomains}
               domains={domains}
               countries={countries}
           />,
           isVisible:true,
           },
           {
               id:3,
               title:'GST',
               component: <GlobalDBARegistriesGSTInfoComponent 
               handleInnerFormChange={handleFormChange}
               selectedDba={selectedDba}
              />,
               isVisible:true,
           },
           {
               id:4,
               title:'PAN',
               component: <DbaRegistriesPanInfoComponent
               handleInnerFormChange={handleFormChange}
               selectedDba={selectedDba}
           />,
           isVisible:true,
           },
           {
               id:5,
               title:'KeyPair',
               component: <GlobalDBARegistriesKeypairInfoComponent 
               handleBacicInnerFormChange={handleInnerFormChange}
               selectedDba={selectedDba}
              />,
              isVisible:id > 0 ? true : false,
           },
  {
    id:6,
    title:'Gateway Registries',
    component:<GlobalDBAGatewayRegistryComponent 
    gatewayIds={gatewayIds}
    selectedDba={selectedDba}
    />,
isVisible:true,
},
  ]
  useEffect(() => {
    const tabTitleFromURL = searchParams.get('tab');
    if (tabTitleFromURL) {
        const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
        if (tabIndex !== -1) {
            setSelectedTabIndex(tabIndex);
        }
    } else {
        setSelectedTabIndex(0);
    }
}, [searchParams]);

const handleTabChange = (index: number) => {
    setSelectedTabIndex(index);
    setSearchParams({ tab: tabItems[index].title });
};

if (selectedTabIndex === null) {
    return null;
} 
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
       <TabContainer tabItems={tabItems}  selectedIndex={selectedTabIndex}
            onChange={handleTabChange}/>
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
          
        </div>
       </div>
  )
}
export default DBAComponent;
